import type { ParsedHttpError } from 'types/error';

export const parseError = (error): ParsedHttpError => {
  const httpStatus = error?.response?.status;
  return { httpStatus, message: error.message };
};
